import React, { useState, useEffect, useContext } from "react";

import TableMainSearch from "../../../common/MainSearch";
import MainBodyTabs from "../../financeTabs";
import MainTitle from "../../../common/MainTitle";

import db from "../../../../services/query";
import {HalfYearContext} from "../../../../contexts/halfYearContext";
import DataTable from "./BenefitTeachersList";
import MainButton from "../../../common/MainButton";
import lbl from "../../../../data/Labels.json";

const BenefitTeachers = (props) => {
  const [data, updateData] = useState([]);
  const [query, setQuery] = useState("");
  const { halfYear } = useContext(HalfYearContext);

  const routeTabs = [
    {
      name: "مصرف ها",
      path: "/mis/expenses/1",
    },
    {
      name: "بودجه ها",
      path: "/mis/expenseBudgets",
    },
    {
      name: "طرف های قرارداد",
      path: "/mis/contractors",
    },
    {
      name: "حسابات قبلی استادان",
      path: "/mis/facultiesPastBalance",
    },
    {
      name: "امتیازات استادان",
      path: "/mis/teacherBenefits",
    },
  ];

  useEffect(() => {
    const ac = new AbortController();

    requestData();

    return () => ac.abort();
  }, [halfYear]);

  const requestData = async () => {
    const { benefit,faculty } = props.match.params;
    try {
      let query = `benefits/types/${benefit}/faculties/${faculty}?halfYearId=${halfYear}`;

      await db.getAll(query).then(({ data }) => {
        updateData(data);
      });
    } catch ({ response }) {
      updateData(response);
    }
  };

  return (
      <div className="main-content">
        <div className="main-content-header">
          <div className="right-content">
            <MainButton title={lbl.PrevPage} type={"back"} />
            <MainTitle title={data?.summary?.title} />
          </div>
          <div className="center-content">
            <TableMainSearch setQuery={setQuery} />
          </div>
          <div className="left-content"></div>
        </div>
        <div className="main-content-body">
          <MainBodyTabs tabs={routeTabs} {...props} />
          <DataTable data={data} {...props} query={query} />
        </div>
      </div>
  );
};

export default BenefitTeachers;
